import {
  AnalyticsEventIdMessage,
  MessageFromParentType,
  MessageToParentType,
  RequestAnalyticsEventIdMessage,
  RequestViewModeMessage,
  RequestVisibilityChangeMessage,
  SetHeaderHeightMessage,
  SetPreferredSizeMessage,
  SetUnseenMessagesCountMessage,
  SetWidgetInitializedMessage,
  ViewMode,
  Visibility,
} from '@stripe-internal/support-conversations-controller';

import {ParentMessageBus} from './ParentMessageBus';

export async function requestAnalyticsEventId(
  bus: ParentMessageBus,
): Promise<string | null> {
  try {
    const msg: RequestAnalyticsEventIdMessage = {
      type: MessageToParentType.RequestAnalyticsEventId,
    };
    const result = await bus.request(
      msg,
      MessageFromParentType.AnalyticsEventId,
    );
    return (result as AnalyticsEventIdMessage).data.analyticsEventId;
  } catch {
    return null;
  }
}

export function requestVisibilityChange(
  bus: ParentMessageBus,
  visibility: Visibility,
): void {
  try {
    const msg: RequestVisibilityChangeMessage = {
      type: MessageToParentType.RequestVisibilityChange,
      data: {
        requestedVisibility: visibility,
      },
    };
    bus.post(msg);
  } catch {}
}

export function sendPreferredSize(
  bus: ParentMessageBus,
  size: {width: number; height: number},
): void {
  try {
    const msg: SetPreferredSizeMessage = {
      type: MessageToParentType.SetPreferredSize,
      data: size,
    };
    bus.post(msg);
  } catch {}
}

export function requestViewMode(
  bus: ParentMessageBus,
  viewMode: ViewMode,
): void {
  try {
    const msg: RequestViewModeMessage = {
      type: MessageToParentType.RequestViewMode,
      data: {viewMode},
    };
    bus.post(msg);
  } catch {}
}

export function sendMinimizedHeight(
  bus: ParentMessageBus,
  height: number,
): void {
  try {
    const msg: SetHeaderHeightMessage = {
      type: MessageToParentType.SetHeaderHeight,
      data: {headerHeight: height},
    };
    bus.post(msg);
  } catch {}
}

export function sendUnseenMessagesCount(
  bus: ParentMessageBus,
  unseenCount: number,
): void {
  try {
    const msg: SetUnseenMessagesCountMessage = {
      type: MessageToParentType.SetUnseenMessagesCount,
      data: {unseenMessagesCount: unseenCount},
    };
    bus.post(msg);
  } catch {}
}

export function sendWidgetInitialized(bus: ParentMessageBus): void {
  try {
    const msg: SetWidgetInitializedMessage = {
      type: MessageToParentType.SetWidgetInitialized,
    };
    bus.post(msg);
  } catch {}
}
